import React from 'react';

const ControlButtonShow = ({ onClick }) => {
    return (
        <button onClick={()=>onClick()} className="hover:scale-110 duration-300" title={"Ver más"}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="blue" class="w-7 h-7">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
        </button>
    );
}

export default ControlButtonShow;